import { PaymentTaskExpenseAccountItem } from '@/hooks/api/models';
import axios from '@/lib/axios';
import queryClient from '@/lib/queryClient';
import { useQuery } from '@tanstack/react-query';

/**
 * 2350. 支払タスク費用科目一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:payment_task_id/payment_task_expense_account_items
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
};

const paymentTaskExpenseAccountItems = (props: Props): Promise<PaymentTaskExpenseAccountItem[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_expense_account_items`,
    { params: props }
  );
};

export const usePaymentTaskExpenseAccountItems = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => paymentTaskExpenseAccountItems(props),
  });
};

export const useInvalidatePaymentTaskExpenseAccountItems = (props: Props) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'purchase_orders',
    props.purchase_order_id,
    'payment_tasks',
    props.task_id,
    'payment_task_expense_account_items',
  ];
};
